import React from 'react';

import StatusBadge from 'shared/ui/Status/StatusBadge';
import {colorIncidentStatus} from 'shared/lib/colors';
import {getPortIncidentStatusLabel} from 'features/port/lib/portIncidentHelper';

interface IPortIncidentStatusBadgeProps {
    isOpen: boolean,
    className?: string,
}

const PortIncidentStatusBadge: React.FC<IPortIncidentStatusBadgeProps> = ({isOpen, className}) => (
    <StatusBadge
        color={colorIncidentStatus(!isOpen)}
        label={getPortIncidentStatusLabel(isOpen)}
        className={className}
    />
);

export default PortIncidentStatusBadge;
